import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 5.8.",
  "description": "",
  "published": "2011-09-05T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today-5-8/swizec/2362"],
  "categories": "Learning, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/09/300px-Something_Is_Expected_Cover2.png",
        "alt": "Something Is Expected",
        "title": "Something Is Expected"
      }}></img></p>
    <p>{`Today I learned that an abundance of studying can be damaging to the brain and general well-being of a person.`}</p>
    <p>{`You can tell something is wrong when at some point you find yourself trying to calculate the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Expected_value",
        "title": "Expected value"
      }}>{`expected value`}</a>{` of a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Random_variable",
        "title": "Random variable"
      }}>{`random variable`}</a>{` defined as {2,2,2,2,2,2,2} using the long form. And you even use so much sense as to shorten everything up by just multiplying the sum of all probabilities with 2! (essentiall 2`}{`*`}{`1)`}</p>
    <p>{`Yep, I actually wrote out two whole members of the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Summation",
        "title": "Summation"
      }}>{`summation`}</a>{` series before realizing what I was doing ...`}</p>
    <p>{`Another thing I learned is that I actually did write down that `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/i-learned-two-things-today-4-8/swizec/2357",
        "title": "I learned two things today 4.8."
      }}>{`thing I said yesterday I didn't write down`}</a>{`, but forgot I had written it down. What I had learned yesterday was that levenshtein distance and hamming distance are pretty similar beasts. The first is a measure of the number of changes you need to perform to turn a string into a different string, whereas the latter is only about the number of substitutions to be performed.`}</p>
    <p>{`And yes, that passes for super interesting these days.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://wpgaurav.wordpress.com/2011/08/31/do-you-multiply-this-way/"
        }}>{`Do you multiply this way!`}</a>{` (wpgaurav.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://awakeninspiration.wordpress.com/2011/07/26/writing-prompts-journaling/"
        }}>{`Writing prompts (Journaling).`}</a>{` (awakeninspiration.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://aplaceforwriters.wordpress.com/2011/09/05/8-things-ive-learned-about-writing/"
        }}>{`8 Things I've Learned About Writing`}</a>{` (aplaceforwriters.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://auroramorealist.wordpress.com/2011/09/05/random-things-about-me/"
        }}>{`10 Random Things About Me`}</a>{` (auroramorealist.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=7127d305-00c3-475d-b340-94e684fc6779",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      